// Multi Sede Usuarios: selector múltiple de sedes (mismo patrón que
// GrupoUsuariosAgregarPage). La PRIMERA sede seleccionada es la primaria
// (TMUSE10.SedCod); todas se registran en el detalle TMUSE20.
import Select from 'react-select';
import { listaEstadosActivo, listaPrivilegios, listaSexo } from "../../../app/constants/constants-selectores";
import { CONST_ROL_MASTER } from "../../../app/constants/constanst-valores";

// Props presentacionales: la lógica (estado, hooks, handlers, API) vive en
// UsuarioFormPage. react-hook-form (register/errors/watch/handleSubmit) y los
// handlers se tipan laxo (`any`) por pragmatismo en la migración.
interface UsuarioFormCamposProps {
    accion: string;
    imagenbase: string;
    handleSubmit: any;
    onSubmitCrear: (...args: any[]) => any;
    onSubmitEditar: (...args: any[]) => any;
    register: any;
    errors: any;
    watch: any;
    listaCompanias: any[];
    listaSucursales: any[];
    listaSedes: any[];
    listaTipoDocumento: any[];
    sedesSeleccionadas: any[];
    setSedesSeleccionadas: (...args: any[]) => any;
    errorSedes: boolean;
    setErrorSedes: (...args: any[]) => any;
    obtenerSucursalesPorCompania: (...args: any[]) => any;
    obtenerSedesPorSucursal: (...args: any[]) => any;
    cambiarTipoDocumento: (...args: any[]) => any;
    handleInputChange: (...args: any[]) => any;
    maxLengthInput: number;
    rol: string;
}

// DT1 (refactor por tamaño): cuerpo de campos del formulario de usuario.
// Toda la lógica (estado, hooks, handlers, API) permanece en UsuarioFormPage;
// aquí sólo vive el JSX presentacional, recibiendo lo necesario por props.
export const UsuarioFormCampos = ({
    accion,
    imagenbase,
    handleSubmit,
    onSubmitCrear,
    onSubmitEditar,
    register,
    errors,
    watch,
    listaCompanias,
    listaSucursales,
    listaSedes,
    listaTipoDocumento,
    sedesSeleccionadas,
    setSedesSeleccionadas,
    errorSedes,
    setErrorSedes,
    obtenerSucursalesPorCompania,
    obtenerSedesPorSucursal,
    cambiarTipoDocumento,
    handleInputChange,
    maxLengthInput,
    rol,
}: UsuarioFormCamposProps) => {
    return (
        <div className="row border p-1 pb-2 rounded-5 g-2">

            <div className="col-12">
                <div className="row ">
                    <div className="col-12 col-lg-6 ">
                        <div className="card align-items-center" style={{ maxHeight: "360px", maxWidth: "360px" }}>
                            <img style={{ maxHeight: "200px", maxWidth: "200px" }} src={imagenbase} className="col-12 img-fluid img-thumbnail" alt="user"></img>
                            <div className="col-12 row">
                                <div className='mt-2 botones-accion text-center'>
                                    {
                                        accion === "agregar" && (
                                            <button className='btn btn-sm btn-primario col-md-3' type="submit" form="CreateForm" onClick={handleSubmit(onSubmitCrear)}>Cargar</button>
                                        )
                                    }
                                    {
                                        accion === "editar" && (
                                            <button className='btn btn-sm btn-primario col-md-3' type="submit" form="CreateForm" onClick={handleSubmit(onSubmitEditar)}>Actualizar</button>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6  row p-1 pb-2 g-2">
                        <div className="col-12">
                            <div className="d-flex align-items-center">
                                <label className="col-4 text-start px-2">Compañía</label>

                                <select
                                    {...register("compania", {
                                        required: {
                                            value: true,
                                        },
                                        onChange: async (e) => {
                                            // MULTI-SEDE ÁRBOL: cambia la compañía padre → el árbol de sedes
                                            // cambia; se limpia la selección previa y se recarga el nuevo árbol.
                                            setSedesSeleccionadas([]);
                                            await obtenerSucursalesPorCompania(e.target.value);
                                            await obtenerSedesPorSucursal(watch("sucursal"));
                                        },
                                    })}
                                    className="form-select form-select-sm"
                                    disabled={accion === "agregar" ? false : true}
                                    value={watch("compania")}
                                >
                                    {
                                        listaCompanias?.length > 0 && listaCompanias.map(c => (
                                            <option key={c?.id} value={c?.id}>{c?.tipo}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            {errors.compania && errors.compania.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese compañía</p>}
                        </div>

                        <div className="col-12  ">
                            <div className="d-flex align-items-center">
                                <label className="col-4 text-start px-2">Sucursal</label>

                                <select
                                    {...register("sucursal", {
                                        required: {
                                            value: true,
                                        },
                                        onChange: async (e) => {
                                            await obtenerSedesPorSucursal(e.target.value);
                                        },
                                    })}
                                    className="form-select form-select-sm"
                                    //disabled={accion == "agregar" ? false : true}
                                    value={watch("sucursal")}
                                    //value={valorSeleccionado}
                                >
                                    <option value="" disabled selected>Seleccione</option>
                                    {
                                        listaSucursales?.length > 0 && listaSucursales.map(c => (
                                            <option key={c?.CompCod} value={c?.CompCod}>{c?.CompNom}</option>
                                        ))
                                    }
                                </select>

                            </div>
                            {errors.compania && errors.compania.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese compañía</p>}
                        </div>

                        <div className="col-12 ">
                            <div className="d-flex align-items-center">
                                <label className="col-4 text-start px-2">Sede</label>
                                {/* Multi Sede Usuarios: selector 1..N (la 1ra sede es la primaria) */}
                                <div className="flex-grow-1">
                                    <Select
                                        isMulti
                                        options={listaSedes?.map(e => ({ value: e?.SedCod, label: e?.SedDesc })) || []}
                                        value={sedesSeleccionadas}
                                        onChange={(seleccion) => {
                                            setSedesSeleccionadas(seleccion || [])
                                            if ((seleccion || []).length > 0) setErrorSedes(false)
                                        }}
                                        placeholder="Seleccione una o varias sedes"
                                        noOptionsMessage={() => "Sin sedes disponibles"}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />
                                </div>
                            </div>
                            {errorSedes && <p role="alert" className="error px-2 mb-0">Seleccione al menos una sede</p>}
                        </div>

                        <div className="col-12 ">
                            <div className="d-flex align-items-center">
                                <label className="col-4 text-start px-2">Usuario</label>
                                <input
                                    {...register("usuario", {
                                        required: { value: true, message: "Ingrese el usuario" },
                                        // INCIDENCIA Validaciones (2026-08-17): el usuario no debe llevar
                                        // espacios ni simbolos (feedback inmediato; el back re-valida).
                                        validate: (v: any) => {
                                            // En editar el usuario es readOnly (no se puede cambiar): no se
                                            // valida para no bloquear la edicion de cuentas legadas.
                                            if (accion === "editar") return true;
                                            const val = (v ?? "").toString();
                                            if (/\s/.test(val)) return "El usuario no debe contener espacios";
                                            if (!/^[A-Za-z0-9._@-]+$/.test(val.trim())) return "El usuario solo puede tener letras, números, punto, guion o guion bajo";
                                            return true;
                                        }
                                    })}
                                    type="text"
                                    className="form-control form-control-sm"
                                    autoComplete="off"
                                    readOnly={accion === "editar" ? true : false}
                                />
                            </div>
                            {errors.usuario && <p role="alert" className="error px-2 mb-0">{errors.usuario.message}</p>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Documento</label>
                    <select {...register("tipo_ide", {
                        required: {
                            value: true,
                        },
                        onChange: (e) => { cambiarTipoDocumento(e.target.value) }
                    })}
                        className="form-select form-select-sm"
                        value={watch("tipo_ide")}
                    >
                        {
                            listaTipoDocumento?.length > 0 && listaTipoDocumento.map(d => (
                                <option key={d?.id} value={d?.id}>{d?.tipo}</option>
                            ))
                        }
                    </select>
                </div>
                {errors.tipo_ide && errors.tipo_ide.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese tipo de documento</p>}
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">

                    <label className="col-4 text-start px-2">Número</label>
                    <input
                        {...register("num_ide", {
                            required: {
                                value: true,
                                message: "Ingrese número"
                            },
                            // INCIDENCIA Validaciones (2026-08-17): primero el mensaje EXACTO ante
                            // simbolos/espacios ("solo números y letras"), luego la longitud por tipo.
                            validate: (v: any) => {
                                const val = (v ?? "").toString().trim();
                                if (!/^[a-zA-Z0-9]+$/.test(val)) return "El número de documento deberá tener solo números y letras.";
                                if (watch("tipo_ide") === "D") return /^\d{8}$/.test(val) || "El DNI debe tener 8 dígitos.";
                                return /^[a-zA-Z0-9]{9,12}$/.test(val) || "El número de documento debe tener entre 9 y 12 caracteres.";
                            }
                        })}
                        type="text"

                        className="form-control form-control-sm"
                        autoComplete="off"
                        maxLength={maxLengthInput}
                        onInput={handleInputChange}
                    />
                </div>
                {errors.num_ide && <p role="alert" className="error px-2 mb-0">{errors.num_ide.message}</p>}
            </div>
            <div className="col-12 col-lg-12">
                <div className="d-flex align-items-center">

                    <label className="col-4 col-lg-2 text-start px-2">Nombres</label>
                    <input
                        {...register("nombre", {
                            required: {
                                value: true,
                            }
                        })}
                        type={"text"}
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
                {errors.nombre && errors.nombre.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese nombres</p>}

            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Ap. Paterno</label>
                    <input
                        {...register("ape_pat", {
                            required: {
                                value: true,
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
                {errors.ape_pat && errors.ape_pat.type === "required" && <p role="alert" className="error px-2 mb-0">Ingrese apellido paterno</p>}
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">

                    <label className="col-4 text-start px-2">Ap. Materno</label>
                    <input
                        {...register("ape_mat")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Teléfono</label>
                    <input
                        {...register("telefono")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Celular</label>
                    <input
                        {...register("celular")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Sexo</label>
                    <select {...register("sexo")} className="form-select form-select-sm" >
                        {
                            listaSexo?.length > 0 && listaSexo.map(s => (
                                <option key={s?.id} value={s?.id}>{s?.tipo}</option>
                            ))
                        }
                    </select>
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Fecha de nacimiento</label>
                    <input
                        {...register("fnacimiento")}
                        type="date"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}

                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Direccion</label>
                    <input
                        {...register("direccion")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Ubigeo</label>
                    <input
                        {...register("ubigeo")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Foto Perfil</label>
                    <input
                        {...register("Imagen", {
                            validate: (value) => {
                                // Verificar si se seleccionó un archivo
                                if (!value[0]) return true;
                                // Verificar si el archivo es una imagen
                                //return value[0].type.startsWith("image/");
                            },
                        })}
                        type="file"
                        className="form-control form-control-sm"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Correo Per</label>
                    <input
                        {...register("email", {
                            // INCIDENCIA Validaciones (2026-08-17): correo opcional; si viene, formato
                            // valido y sin espacios (mismo criterio que el back).
                            validate: (v: any) => {
                                const val = (v ?? "").toString().trim();
                                if (!val) return true;
                                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) || "Correo personal no válido (ejemplo: usuario@dominio.com)";
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
                {errors.email && <p role="alert" className="error px-2 mb-0">{errors.email.message}</p>}
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Correo Lab</label>
                    <input
                        {...register("email_lab", {
                            // INCIDENCIA Validaciones (2026-08-17): correo laboral opcional; mismo criterio.
                            validate: (v: any) => {
                                const val = (v ?? "").toString().trim();
                                if (!val) return true;
                                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) || "Correo laboral no válido (ejemplo: usuario@dominio.com)";
                            }
                        })}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
                {errors.email_lab && <p role="alert" className="error px-2 mb-0">{errors.email_lab.message}</p>}
            </div>

            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Fecha de ingreso</label>
                    <input
                        {...register("fingreso")}
                        type="date"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Area</label>
                    <input
                        {...register("area")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Anexo</label>
                    <input
                        {...register("anexo")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">IP</label>
                    <input
                        {...register("ip")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Usuario kpc</label>
                    <input
                        {...register("usuariokpc")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Clave kpc</label>
                    <input
                        {...register("clavekpc")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Id huella</label>
                    <input
                        {...register("useridhuella")}
                        type="text"
                        className="form-control form-control-sm"
                        autoComplete="off"
                        style={{ textTransform: "none" }}
                    />
                </div>
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-center">
                    <label className="col-4 text-start px-2">Estado</label>
                    <select {...register("estado")} className="form-select form-select-sm" >
                        {
                            listaEstadosActivo?.length > 0 && listaEstadosActivo.map(e => (
                                <option key={e?.id} value={e?.id}>{e?.tipo}</option>
                            ))
                        }
                    </select>
                </div>
            </div>
            {/* <div className="col-12 col-lg-6">
            <div className="d-flex align-items-center">
                <label className="col-4 text-start px-2">Permiso</label>
                <select {...register("permiso")} className="form-select form-select-sm" >
                    {
                        listaPermisos?.length > 0 && listaPermisos.map(p => (
                            <option key={p?.id} value={p?.id}>{p?.tipo}</option>
                        ))
                    }
                </select>
            </div>
        </div> */}
            {
                rol === CONST_ROL_MASTER && (
                    <div className="col-12 col-lg-6">
                        <div className="d-flex align-items-center">

                            <label className="col-4 text-start px-2">Privilegio</label>
                            <select {...register("privilegio")} className="form-select form-select-sm" >
                                {
                                    listaPrivilegios?.length > 0 && listaPrivilegios.map(p => (
                                        <option key={p?.id} value={p?.id}>{p?.tipo}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                )
            }


        </div>
    )
}
